var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"costom-scrollar",class:_vm.style},[_vm._t("scrollbar")],2)}
var staticRenderFns = []

export { render, staticRenderFns }